import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { evaluatePublisherGuestRouteGuard } from "../services/publisherGuestRouteGuard";

type PublisherGuestRouteProps = {
  children: ReactNode;
};

export function PublisherGuestRoute({ children }: PublisherGuestRouteProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const decision = evaluatePublisherGuestRouteGuard({
    isLoading,
    user,
    entryPath: location.pathname,
  });

  if (decision.action === "loading") {
    return (
      <div className="container py-5 text-center text-muted">Loading...</div>
    );
  }

  if (decision.action === "redirect") {
    return <Navigate replace to={decision.to} />;
  }

  return children;
}
